/*
 * @Description: 路由跳转控制中心
 * @Date: 2019-07-22 15:13:52
 * @LastEditTime: 2019-07-26 22:38:03
*/

import Vue from 'vue'
import Router from 'vue-router'

import loginRoutes from './login'
import aboutRoutes from './about'
import customerRoutes from './customer'
import homeRoutes from './home'
// import millRoutes from './mill'
// import earningsRoutes from './earnings'
import userRoutes from './user'
import noticeRoutes from './notice'
// import minerHome from './miner-home'
import dataPanel from './data-panel'
import errorRoutes from './error'
import inviteRoutes from './invite'
import downloadRoutes from './download'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const children = [
  ...loginRoutes,
  ...aboutRoutes,
  ...customerRoutes,
  ...homeRoutes,
  ...userRoutes,
  ...noticeRoutes,
  ...dataPanel,
  ...inviteRoutes,
  ...downloadRoutes
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main'], resolve),
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
  const { path, query } = to;
  if (path == "/pages/user/login") {
    router.push({ path: "/login" })
    return
  } else if (path.indexOf("register") > -1) {
    if (!query.code) {
      router.push({ path: "/login?code=" + query.code })
    } else {
      router.push({ path: "/login" })
    }
    return
  } else if (path.indexOf("/mill") > -1 || path.indexOf("/earnings") > -1) {
    if (query.walletAddr) {
      router.push({ path: `/data-panel?walletAddr=${query.walletAddr}&currency=${query.currency}` });
    } else {
      router.push({ path: "/home" });
    }

    return
  } else if (path.indexOf("/pages/user/resetPwd") > -1) {
    router.push({ path: "/reset" })
    return
  } else if (path.indexOf("/pages/download/index") > -1) {
    router.push({ path: "/download" })
    return
  } else {
    if (query.type == 1) {
      if (query.walletAddr) {
        router.push({ path: `/data-panel?walletAddr=${query.walletAddr}&currency=${query.currency}` });
      } else {
        router.push({ path: "/home" });
      }
      return
    }

    if (path.indexOf("/pages/") > -1) {
      router.push({ path: "/login" });
      return
    }
  }
  window.scroll(0, 0);
  next();
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js